import React, { useState } from 'react';
import './CarSingle.css';

import { Button, PageTitle, Comments, FeaturedCars, SidebarHeading } from '../../../components';
import { calculateAverageRating, countCommentsAndReplies, renderIcon } from '../../../utils';

import { FaStar, FaCheck } from 'react-icons/fa';

import { useLocation } from 'react-router-dom'; 
import ImageGallery from 'react-image-gallery';



const CarSingle = () => {

  // State for managing the selected information tab
  const [selectedOption, setSelectedOption] = useState('description');

  // Get car data from the location state
  const location = useLocation();  
  const car = location.state;  

  // Extract car details and reviews
  const specs = car.details;
  const carReviews = car.comments;

  // Generate the car name by combining make and model
  const carName = `${car.details.carMake} ${car.details.carModel}`;

  // Calculate the total number of comments and replies for the product
  let totalCommentsAndReplies = 0;
  if (carReviews) {
    totalCommentsAndReplies = countCommentsAndReplies(carReviews);
  }
  
  // Calculate the average rating for the Car
  const averageRating = calculateAverageRating(car);

  // Handle option change for the Car information tabs
  const handleOptionChange = (option) => {
    setSelectedOption(option);
  }; 

  // Handle form submission for adding a review/comment
  const handleSubmit = (event) => {

    event.preventDefault(); // Prevent the default form submission behavior

    const formData = new FormData(event.target);
    const values = Object.fromEntries(formData.entries());

    // Check if all input fields are filled
    const isFormValid = Object.values(values).every((value) => value.trim() !== '');

    if (isFormValid) {
      // Reset the form fields
      event.target.reset();
    }

  };

  // Function to split the details into groups of 3
  const splitIntoChunks = (arr, chunkSize) => {
    const result = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      result.push(arr.slice(i, i + chunkSize));
    }
    return result;
  };

  // Create an array of images for the image gallery
  const image = [  
    {
      original: car.gallery.image1,
      thumbnail:  car.gallery.image1,
    },
    {
      original: car.gallery.image2,
      thumbnail:  car.gallery.image2,
    },
    {
      original: car.gallery.image3,
      thumbnail:  car.gallery.image3,
    },
    {
      original: car.gallery.image4,
      thumbnail:  car.gallery.image4,
    },
  ];

  // Convert car details into an array of key-value pairs and split them into groups of 3
  const detailEntries = Object.entries(specs);
  const detailChunks = splitIntoChunks(detailEntries, 3); // Split into chunks of 3

  return (
    <>
      {/* Page title */}
      <PageTitle title={'car single'} page={'car single'} />

      {/* Car Single Section */}
      <section className='car-single product-single'>

        {/* Car Description */}
        <div className='car-description product-des'>
 
          <div className='product-container'>

            {/* Car Image Gallery */}
            <div className='image'>
              <ImageGallery items={image} /> 
            </div>

            {/* Car Details & Info */}
            <div className='content'>
              <div className='text'>

                {/* Car Intro */}
                <div className='car-intro'>
                  
                  <div>
                    <h2>{carName}</h2> {/* Car Name */}
                    <div className='rating'>  {/* Car Rating */}
                      <div className='icon'>            
                        <FaStar /> <FaStar /> <FaStar /> <FaStar /> <FaStar /> 
                      </div> 
                      {/* Render average rating and comment count */}
                      {carReviews.length > 0 ? (
                        <h5>{averageRating} ({carReviews.length})</h5>
                      ) : (
                        <h5>Not rated</h5>
                      )}
                    </div> 
                  </div>

                  <div className='price'>${car.price}</div> {/* Car Price */}

                </div>

                {/* Action Buttons */}
                <div className='btn-container'>
                  <Button link={'Contact-us'} title={'Schedule a Test Drive'} />
                  <Button link={'GetQuote'} title={'Request a Quote'} />
                </div>

                {/* Car Specifications */}
                <div className="details">
                  {detailChunks.map((chunk, chunkIndex) => (
                    <div className="detail-group" key={chunkIndex}>
                      {chunk.map(([key, value], index) => (
                        <div className="detail-item" key={index}>
                          <div className='icon'>{renderIcon(key)}</div>
                          <div className="detail-content">
                            <strong>{key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}</strong>
                            <span>{value}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
                    
              </div>
            </div>

          </div>

          {/* Car Information Tabs */}
          <div className='car-info page-info'>

            {/* Product Information Tab */}
            <div className="car-info-tabs tab-buttons">

              {/* Description Tab */}
              <button
                type="button"
                className={`button ${selectedOption === 'description' ? 'active' : ''}`}
                onClick={() => handleOptionChange('description')}>
                description
              </button>

              {/* Additional Information Tab */}
              <button
                type="button"
                className={`button ${selectedOption === 'Features' ? 'active' : ''}`}
                onClick={() => handleOptionChange('Features')}>
                Features
              </button>

              {/* Reviews Tab */}
              <button
                type="button"
                className={`button ${selectedOption === 'reviews' ? 'active' : ''}`}
                onClick={() => handleOptionChange('reviews')}>
                reviews ({totalCommentsAndReplies})
              </button>

            </div>

            {/* Description Container */}
            {selectedOption === 'description' && (
              <div className="description car-info-gallery">
                <p>{car.description}</p>
              </div>
            )}

            {/* Additional Information Container */}
            {selectedOption === 'Features' && (

                <div className='features-container sub-section car-info-gallery'>
                {Object.entries(car.features).map(([category, items]) => (
                  <div className='item' key={category}>
                    <h6>{category.charAt(0).toUpperCase() + category.slice(1)}</h6>
                    <ul>
                      {items.map((feature, index) => (
                        <li key={index}><FaCheck className='icon' />{feature}</li>
                      ))}
                    </ul>
                  </div>
                ))}
                </div>

            )}

            {/* Reviews Container */}
            {selectedOption === 'reviews' && (
              <div className='reviews car-info-gallery'>
                {/* Reviews */}
                <Comments comments={carReviews} />
                <div className='leave-reply'>
                  {/* Leave a Comment Form */}
                  <form className='form' onSubmit={handleSubmit}>
                    <h2>leave a comment</h2>  
                    <div className='input-box'>
                      <input type="text" name="name" className='box' id="name" placeholder="name" required />
                      <input type="email" name="email" className='box' id="email" placeholder="email" required />
                    </div>
                    <textarea cols="30" rows="10" name="comment" className='box' id="comment" placeholder="comment"></textarea>
                    <button type="submit" name="submit" id="submit" className='btn'>submit</button>
                  </form>
                </div>
              </div>
            )}

          </div>

        </div>

        {/* featured cars Section */}
        <div className='featured-items'> 

          {/* Sidebar Heading */}
          <SidebarHeading title='featured cars' />

          {/* Render the featured cars */}
          <FeaturedCars />

        </div>

      </section>
    </>
  )
}

export default CarSingle;